var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"challenge"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}}),_c('hr'),_c('Gallery',{attrs:{"directory":_vm.galleryFolder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }